import React, { useMemo } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectKeysWaitingQueueItems,
    selectQueueDescription,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import SupervisorBarQueueItem from '../SupervisorBarQueueItem';
import WaitingQueueItemsInfo from './WaitingQueueItemsInfo';

interface Props {
    queueKey: QueueKey;
}

const SectionWaitingQueueItems = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();
    const queueItemKeysNotSorted = useAppSelector((state) =>
        selectKeysWaitingQueueItems(state, queueKey),
    );

    const queueItemKeys = useMemo(
        () => queueItemKeysNotSorted?.reverse().slice(0, 100),
        [queueItemKeysNotSorted],
    );

    const queueName = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );

    return (
        <div className="flex h-4 w-full cursor-default flex-row gap-1.5">
            <WaitingQueueItemsInfo
                queueKey={queueKey}
                number={queueItemKeysNotSorted?.size}
            />
            <div className="flex flex-row-reverse items-center gap-x-px overflow-x-auto">
                {queueItemKeys && !queueItemKeys.isEmpty() ? (
                    queueItemKeys.map((itemKey: any, index: number) => (
                        <SupervisorBarQueueItem
                            queueName={queueName}
                            queueCallKey={itemKey}
                            key={`bar-${itemKey}`}
                            position={queueItemKeys.size - index}
                        />
                    ))
                ) : (
                    <span className="text-xs text-gray-400 dark:text-gray-800">
                        {i18next.t('Supervisor.QueueRow.NothingInQueue')}
                    </span>
                )}
            </div>
        </div>
    );
};

export default SectionWaitingQueueItems;
